"use strict";

var LIMIT = 20;

function createdAtIs(prop) {
  return function(a) {
    a.createdAt = a[prop];
    
    return a;
  };
}

function identity(a) {
  return a;
}

function CompanyPublicationActivityFactory(config, $q, $http) {
  function Source(uri, type, parse) {
    this._uri       = uri;
    this._type      = type;
    this._parse     = typeof parse === "function" ? parse : identity;
    this._data      = [];
    this._exhausted = false;
    this._loading   = null;
    this._setType   = function(a) {
      a.activityType = type;

      return a;
    };
  }
  
  Source.prototype.next = function(offset) {
    var self = this;
    
    if(this._loading) {
      /* Wait until current loading is done, then try again */
      return this._loading.then(function() {
        return self.next(offset, offset + 1);
      });
    }

    if(offset + 1 < this._data.length || this._exhausted) {
      /* Already cached or nothing more to fetch */
      return this._data.slice(offset, offset + 1);
    }
    
    var uri = this._uri + (this._uri.indexOf("?") === -1 ? "?" : "&" ) + "offset=" + this._data.length + "&limit=" + (LIMIT + 1);

    this._loading = $http({
      method: "GET",
      url:    config.apiBase + uri,
    }).then(function(response) {
      /* We got fewer items than we asked for, source is exhausted */
      if(response.data.length < LIMIT + 1) {
        self._exhausted = true;
      }

      self._data    = self._data.concat(response.data.map(self._parse).map(self._setType));
      self._loading = null;
      
      return self._data.slice(offset, offset + 1);
    });
    
    return this._loading;
  };
  
  Source.prototype.isExhausted = function() {
    return this._exhausted;
  };
  
  Source.prototype.numLoaded = function() {
    return this._data.length;
  };
  
  Source.prototype.getType = function() {
    return this._type;
  };
  
  Source.prototype.prependData = function(data) {
    this._data = data.map(this._setType).concat(this._data);
  };

  function CompanyPublicationActivity(companyId, publicationId, q) {
    this._sources = [
      new Source("/companies/" + companyId + "/comments?objectId=" + publicationId + (q ? ("&text=" + q + "&title=" + q) : ""), "COMMENT"),
      new Source("/companies/" + companyId + "/feed?objectId=" + publicationId, "AUDITLOG", createdAtIs("performedAt"))
    ];
  }
  
  CompanyPublicationActivity.prototype.prependDataTo = function(type /* , ... */) {
    var source = null;
    
    this._sources.forEach(function(s) {
      if(s.getType() === type) {
        source = s;
      }
    });

    if(source) {
      source.prependData.call(source, Array.prototype.slice.call(arguments, 1));

      return true;
    }
    else {
      return false;
    }
  };

  CompanyPublicationActivity.prototype.next = function(offset, limit, types) {
    offset = typeof offset === "number" ? offset : 0;
    limit  = typeof limit  === "number" ? limit  : LIMIT;
    types  = Array.isArray(types) && types.length > 0 ? types : this._sources.map(function(s) { return s.getType(); });

    var list    = [];
    var d       = $q.defer();
    var sources = this._sources.filter(function(s) {
      return types.indexOf(s.getType()) !== -1;
    }).map(function(s) {
      return {
        offset : 0,
        source:  s
      };
    });

    /**
     * Unless we have enough data or exhausted all sources, take
     * the newest item from any of the sources and increment the
     * offset counter for that source and repeat.
     */
    function consume() {
      if(list.length === limit + offset || sources.every(function(v) { return v.source.numLoaded() === v.offset && v.source.isExhausted(); })) {
        d.resolve(list.slice(offset));

        return;
      }
      
      /* Read one item off all sources */
      $q.all(sources.map(function(s) {
        return s.source.next(s.offset);
      })).then(function(datas) {
        var min      = null;
        var selected = null;

        for(var i = 0; i < datas.length; i++) {
          if(datas[i].length > 0 && (min === null || new Date(datas[i][0].createdAt) > new Date(min.createdAt))) {
            min      = datas[i][0];
            selected = i;
          }
        }
        
        if( ! min) {
          d.resolve(list.slice(offset));
          
          /* All are consumed */
          return;
        }
        
        /* We got the most current event out of all datas,
         * consume that and increase the offset for the source. */
        list.push(min);
        
        sources[selected].offset++;

        consume();
      }, function(e) {
        d.reject(e);
      });
    }
    
    consume();
    
    return d.promise;
  };

  return CompanyPublicationActivity;
}

angular.module("dokiv")
  .factory("CompanyPublicationActivity", ["config", "$q", "$http", CompanyPublicationActivityFactory]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationActivity.js
// module id = 6
// module chunks = 0